import React from 'react';
import './Experience.css';
import unoLogo from '../assets/uno_logo.png';
import samsungLogo from '../assets/samsung_logo.png';

const EXPERIENCE_ITEMS = [
  {
    role: 'Graduate Research Assistant',
    organization: 'University of Nebraska Omaha',
    location: 'Omaha, NE, USA',
    dates: 'Jan. 2026 – Present',
    logo: unoLogo,
    bullets: [
      'Conduct research in AI for 6G communication networks and UAV-based autonomous systems.',
      'Design machine learning and deep reinforcement learning models for congestion-aware control and adaptive data transmission.',
      'Build simulation and real-world deployment environments for digital twins and evaluate end-to-end system performance.',
    ],
  },
  {
    role: 'Instructor of Record',
    organization: 'University of Nebraska Omaha',
    location: 'Omaha, NE, USA',
    dates: 'Aug. 2025 – Dec. 2025',
    logo: unoLogo,
    bullets: [
      'Taught computer science and data analytics while maintaining active networking research.',
      'Designed instructional materials, delivered lectures and labs, and evaluated student work.',
      'Supervised programming-heavy coursework and project execution.',
    ],
  },
  {
    role: 'Graduate Research Assistant',
    organization: 'University of Nebraska Omaha',
    location: 'Omaha, NE, USA',
    dates: 'Aug. 2022 – Jun. 2025',
    logo: unoLogo,
    bullets: [
      'Conducted research on AI-driven communication systems and autonomous cyber-physical platforms.',
      'Evaluated deep learning models for digital twins and analyzed 5G radio interface behavior to characterize encrypted traffic.',
      'Developed sensor integration workflows using LiDAR, camera, GNSS, ROS, and Autoware.',
    ],
  },
  {
    role: 'Software Engineer',
    organization: 'Samsung R&D Institute Bangladesh',
    location: 'Dhaka, Bangladesh',
    dates: 'Dec. 2018 – Jul. 2022',
    logo: samsungLogo,
    bullets: [
      'Designed and implemented cloud-integrated IoT systems for fetching, parsing, storing, and presenting device data.',
      'Built onboarding frameworks to securely integrate IoT devices into large-scale cloud environments.',
      'Worked on production-grade systems supporting connected-device experiences.',
    ],
  },
];

const Experience = () => {
  return (
    <section id="experience" className="site-section" aria-labelledby="experience-heading">
      <div className="site-section-inner experience-shell">
        <div className="section-heading">
          <p className="section-kicker">Experience</p>
          <h2 id="experience-heading" className="section-title">Research, Teaching, and Industry Work</h2>
          <p className="section-intro">
            My work spans graduate research, teaching, and production software
            engineering, with a consistent focus on intelligent systems and
            networked platforms.
          </p>
        </div>

        <div className="experience-timeline">
          {EXPERIENCE_ITEMS.map((item) => (
            <article key={`${item.role}-${item.dates}`} className="experience-card card-surface">
              <div className="experience-card-header">
                <div className="experience-logo-shell">
                  <img src={item.logo} alt={`${item.organization} logo`} className="company-logo" />
                </div>
                <div className="experience-copy">
                  <div className="experience-heading-row">
                    <h3>{item.role}</h3>
                    <span className="eyebrow-chip">{item.dates}</span>
                  </div>
                  <p className="experience-organization">{item.organization}</p>
                  <p className="experience-location">{item.location}</p>
                </div>
              </div>

              <ul className="experience-bullets">
                {item.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
